import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IUsageInfo } from '../../../spacesPlatform/models/IUsageInfo';
import { INamedItem, ITypedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { FlowListItem } from '../types/Flow';

export type GetFlowsParams = IGetItemsParams;

export type GetFlowsResult = IGetItemsResult & {
  flows?: FlowListItem[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  favorites?: string[];
  maxStats?: IUsageInfo;
};

export class GetFlowsRequest extends Request<GetFlowsParams, GetFlowsResult> {
  constructor(params: GetFlowsParams) {
    super('getFlows', params);
  }
}
